module.exports = __webpack_public_path__ + "img/PSG.bf059de0.png";